import React, {useState} from 'react';
import FileInput from "@/Shared/FileInput";
import {useDispatch} from "react-redux";
import {openModal} from "@/Store/Slices/ModalSlice";
import {setImage} from "@/Store/Slices/ImageSlice";

const ImageInput = ({errors, value, onChange, name, label}) => {
  const dispatch = useDispatch();

  function handleChange(file) {
    if (file) {
      dispatch(openModal({ modalType: 'upload-image' }))
      dispatch(setImage({ src: URL.createObjectURL(file) }))
      onChange(file)
    }
  }


  return (
    <>
      <FileInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label={label}
        name={name}
        accept="image/*"
        errors={errors}
        value={value}
        onChange={handleChange}
      />

    </>
  );
};

export default ImageInput;
